import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';

@Component({
  selector: 'app-update-dependent-address-modal',
  templateUrl: './update-dependent-address-modal.component.html',
  styleUrls: ['./update-dependent-address-modal.component.css']
})
export class UpdateDependentAddressModalComponent implements OnInit {
  @Input() data: { [key: string]: any };
  dependents: any[];
  hasSelected: boolean;
  constructor(private employeeservice: EmployeeService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.dependents = [];
    this.hasSelected = false;
    this.employeeservice.getDependents().then((response: any) => {
      if (!response || response == undefined || response.length == 0) {
        this.activeModal.close;
      }
      else {
        this.dependents = response;
      }
    });
  }

  updateDependent() {
    this.dependents.forEach(dependent => {
      if (dependent.selected) {
        var listItem = [{ Name: "Address", Value: this.data.Address }, { Name: "Zip", Value: this.data.Zip }, { Name: "City", Value: this.data.City }, { Name: "State", Value: this.data.State }];
        this.employeeservice.submitDependents(dependent.KeyID, listItem, false, null);
      }
    });
    this.activeModal.close();
  }

  checkIfAnySelected() {
    var isSelected = false;
    this.dependents.forEach(dependent => {
      if (dependent.selected) {
        isSelected = true;
      }
    });
    this.hasSelected = isSelected;
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

}
